import React from 'react';
import { NavLink } from 'react-router-dom';
import { MonetaryFloatInput, FloatInput } from '../../components/common/MonetaryFloatInput';
import ModalDescriptionHint from '../../components/common/ModalDescriptionHint';
import { range } from '../../helpers';
import { floatRenderer, thousandsFloatRenderer } from '../../services/formatSvc';
import { isAdmin } from '../../services/rolesSvc';

import { BaseRequests } from '../../requests/BaseRequests';

export const renderNameTooltip = (rowData) => (
  <>
    {rowData.name}
    <ModalDescriptionHint headerText={rowData.fullName || rowData.name}>
      {rowData.calcDescr}
    </ModalDescriptionHint>
  </>
);

export const renderUnifiedPcsName = (rowData, params, navProject) => {
  const name = rowData.name

  return rowData?.countEntity && !rowData?.parentId
    // ссылка на страницу показателя на уровне программы
    ? <NavLink to={BaseRequests.getUrlSearch(`/indexes/unified-part/${rowData.countEntity}`, {
        type: rowData?.type,
        entityId: rowData?.entityId,
        reportType: rowData.reportType,
        indexName: encodeURI(name),
        ...params
      })}
        onClick={() => navProject.setIndexName(name)}
      >
        {name}
      </NavLink>
    : rowData?.countEntity && rowData?.type === 'strategy'
    // ссылка на страницу показателя на уровне СП
    ? <NavLink to={BaseRequests.getUrlSearch(`/indexes/unified-part/${rowData.countEntity}/strats/${rowData.entityId}`, {
        entityId: rowData.parentId,
        stratName: encodeURI(name),
        stratId: rowData.entityId,
        hasPortfolio: Boolean(rowData.tableData.childRows)
      })}
        onClick={() => navProject.setIndexName(name)}
      >
        {name}
      </NavLink>
    // название показателя без ссылок
    :<span>{name}</span>;
};

export const renderCompleteValue = (value) => (value !== null && value !== undefined ? `${floatRenderer(value)}%` : '-');

export const renderNamesString = (names) => (names ? names.split(', ').map((n, i) => (
  <span key={i}>
    {n}
    <br />
  </span>
)) : '');

const renderNullableValue = (value, handler = (v) => v) =>
  (typeof value !== 'undefined' ? handler(value) : '-');

export const renderNullFloatValues = (value) => renderNullableValue(value, floatRenderer);
export const renderNullThousandsFloatValues = (value) => renderNullableValue(value, thousandsFloatRenderer);
export const renderNullStringValues = (value) => renderNullableValue(value);

const convertToThousands = (value) => renderNullableValue(value, (v) => thousandsFloatRenderer(v / 1000));

export const getFieldRenderFunction = (rowData) => {
  switch (rowData.unit) {
    case 'тыс. руб.':
      return renderNullThousandsFloatValues;
    case 'рублей':
      return convertToThousands;
    default:
      return renderNullFloatValues;
  }
};

export const indexValueRenderer = (unit, value) => {
  if(!value && value !== 0){
    return '-'
  }
  switch (unit) {
    case 'тыс. руб.':
      return renderNullThousandsFloatValues(value);
    case 'рублей':
      return convertToThousands(value);
    default:
      return new Intl.NumberFormat('ru', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(value);
  }
}

export const renderEditMoneyComponent = (props) => {
  switch (props.rowData.unit) {
    case 'рублей':
      return <MonetaryFloatInput value={props.value} onChange={props.onChange} table />;

    default:
      return <FloatInput value={props.value} onChange={props.onChange} table />;
  }
};

const isReviewGroup = (userCtx) => userCtx.perms && (userCtx.perms.includes('reviewGroup'));

// check rights to edit
export const isUserChargedForRow = (rowData, userCtx) => {
  if (isAdmin(userCtx)) return true;
  if (userCtx.perms && userCtx.perms.includes('kpiAdmin')) {
    return userCtx.user && rowData.users.map((u) => u.id).includes(userCtx.user.id);
  }
  return false;
};

// check rights to read
export const isRowVisibleForUser = (rowData, userCtx) => {
  if (isReviewGroup(userCtx)) return true;
  return isUserChargedForRow(rowData, userCtx);
};

export const getIsOpenPeriodsSelected = (filterYears, periodsInfo) => {
  return periodsInfo
    .filter((period) => !period.isClosed)
    .map((period) => period.year)
    .some((year) => filterYears.includes(year));
}

export const filterKpisByYear = (k, years) => {
  if (!k.startYear && !k.endYear) return k;
  const krange = range(k.startYear ?? 2020, k.endYear ?? 2030);
  return krange.find((r) => years.includes(r));
};
